export default __webpack_public_path__ + "static/media/fam_icon.8f8d66bf.jpg";